import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  car: [],
  storageMode: null, // VAULT | ARCHIVE
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/car/index.js